import React, { useEffect, useState } from "react"
import CategoryItem from "./CategoryItem"
import { Container } from "../styles/CategoriesStyle"
import { serverAPI } from "../services/apiParams"

const Categories = () => {
  const [categories, setCategories] = useState()

  useEffect(() => {
    const getCategories = async () => {
      try {
        const res = await serverAPI.get("/api/popular_categories")
        const mostPopularCategories3 = res.data.slice(0, 3)
        setCategories(mostPopularCategories3)
      } catch (error) {
        console.log(error.response)
      }
    }
    getCategories()
  }, [])

  return (
    <Container>
      {categories &&
        categories.map((item) => (
          <CategoryItem item={item} key={item.category_id} />
        ))}
    </Container>
  )
}

export default Categories
